export const GALAXY_MAP_DATA = {
  "gridConfig": {
    "cols": 41,
    "rows": 41,
    "cellSize": 100
  },
  "tiles": [
    {
      "seed": "-1-1",
      "x": -1,
      "y": 1,
      "tier": 6,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "0-1",
      "x": 0,
      "y": 1,
      "tier": 6,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "1-1",
      "x": 1,
      "y": 1,
      "tier": 6,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "2-1",
      "x": 2,
      "y": 1,
      "tier": 6,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "-1-0",
      "x": -1,
      "y": 0,
      "tier": 6,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "0-0",
      "x": 0,
      "y": 0,
      "tier": 6,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "1-0",
      "x": 1,
      "y": 0,
      "tier": 6,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "2-0",
      "x": 2,
      "y": 0,
      "tier": 6,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-1--1",
      "x": -1,
      "y": -1,
      "tier": 6,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "0--1",
      "x": 0,
      "y": -1,
      "tier": 6,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "1--1",
      "x": 1,
      "y": -1,
      "tier": 6,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "2--1",
      "x": 2,
      "y": -1,
      "tier": 6,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-1--2",
      "x": -1,
      "y": -2,
      "tier": 6,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "0--2",
      "x": 0,
      "y": -2,
      "tier": 6,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "1--2",
      "x": 1,
      "y": -2,
      "tier": 6,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "2--2",
      "x": 2,
      "y": -2,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "3-0",
      "x": 3,
      "y": 0,
      "tier": 5,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "3--1",
      "x": 3,
      "y": -1,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "3--2",
      "x": 3,
      "y": -2,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4-0",
      "x": 4,
      "y": 0,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "3--3",
      "x": 3,
      "y": -3,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--1",
      "x": 4,
      "y": -1,
      "tier": 5,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "4--2",
      "x": 4,
      "y": -2,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--3",
      "x": 4,
      "y": -3,
      "tier": 5,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--1",
      "x": 5,
      "y": -1,
      "tier": 5,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "3--4",
      "x": 3,
      "y": -4,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "5--2",
      "x": 5,
      "y": -2,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--4",
      "x": 4,
      "y": -4,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--3",
      "x": 5,
      "y": -3,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--4",
      "x": 5,
      "y": -4,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--3",
      "x": 6,
      "y": -3,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "4--5",
      "x": 4,
      "y": -5,
      "tier": 4,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "5--5",
      "x": 5,
      "y": -5,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--4",
      "x": 6,
      "y": -4,
      "tier": 4,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "5--6",
      "x": 5,
      "y": -6,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--5",
      "x": 6,
      "y": -5,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--6",
      "x": 6,
      "y": -6,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--7",
      "x": 4,
      "y": -7,
      "tier": 4,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "5--7",
      "x": 5,
      "y": -7,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--7",
      "x": 6,
      "y": -7,
      "tier": 3,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "4--8",
      "x": 4,
      "y": -8,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--8",
      "x": 5,
      "y": -8,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "6--8",
      "x": 6,
      "y": -8,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--9",
      "x": 4,
      "y": -9,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--9",
      "x": 5,
      "y": -9,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "4--10",
      "x": 4,
      "y": -10,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "5--10",
      "x": 5,
      "y": -10,
      "tier": 3,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "3--10",
      "x": 3,
      "y": -10,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "3--11",
      "x": 3,
      "y": -11,
      "tier": 3,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "4--11",
      "x": 4,
      "y": -11,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "2--11",
      "x": 2,
      "y": -11,
      "tier": 3,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "2--12",
      "x": 2,
      "y": -12,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "3--12",
      "x": 3,
      "y": -12,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "4--12",
      "x": 4,
      "y": -12,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "1--12",
      "x": 1,
      "y": -12,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "2--13",
      "x": 2,
      "y": -13,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "1--13",
      "x": 1,
      "y": -13,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "3--13",
      "x": 3,
      "y": -13,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "0--13",
      "x": 0,
      "y": -13,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "1--14",
      "x": 1,
      "y": -14,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "0--14",
      "x": 0,
      "y": -14,
      "tier": 2,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "-1--14",
      "x": -1,
      "y": -14,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-2--14",
      "x": -2,
      "y": -14,
      "tier": 2,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "0--15",
      "x": 0,
      "y": -15,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-1--15",
      "x": -1,
      "y": -15,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-2--15",
      "x": -2,
      "y": -15,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-3--15",
      "x": -3,
      "y": -15,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-4--15",
      "x": -4,
      "y": -15,
      "tier": 2,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-3--16",
      "x": -3,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-5--15",
      "x": -5,
      "y": -15,
      "tier": 2,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-4--16",
      "x": -4,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-5--16",
      "x": -5,
      "y": -16,
      "tier": 1,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "-6--15",
      "x": -6,
      "y": -15,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-6--16",
      "x": -6,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-7--15",
      "x": -7,
      "y": -15,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-7--16",
      "x": -7,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-8--15",
      "x": -8,
      "y": -15,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-8--16",
      "x": -8,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-9--15",
      "x": -9,
      "y": -15,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-9--16",
      "x": -9,
      "y": -16,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-10--15",
      "x": -10,
      "y": -15,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-10--16",
      "x": -10,
      "y": -16,
      "tier": 1,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-11--15",
      "x": -11,
      "y": -15,
      "tier": 1,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "2--3",
      "x": 2,
      "y": -3,
      "tier": 5,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "1--3",
      "x": 1,
      "y": -3,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "1--4",
      "x": 1,
      "y": -4,
      "tier": 5,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "2--4",
      "x": 2,
      "y": -4,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "0--4",
      "x": 0,
      "y": -4,
      "tier": 5,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "0--5",
      "x": 0,
      "y": -5,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "1--5",
      "x": 1,
      "y": -5,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "2--5",
      "x": 2,
      "y": -5,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "3--5",
      "x": 3,
      "y": -5,
      "tier": 4,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "0--6",
      "x": 0,
      "y": -6,
      "tier": 4,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "1--6",
      "x": 1,
      "y": -6,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "2--6",
      "x": 2,
      "y": -6,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "3--6",
      "x": 3,
      "y": -6,
      "tier": 4,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "1--7",
      "x": 1,
      "y": -7,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "0--7",
      "x": 0,
      "y": -7,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "2--7",
      "x": 2,
      "y": -7,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-1--7",
      "x": -1,
      "y": -7,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "1--8",
      "x": 1,
      "y": -8,
      "tier": 4,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "0--8",
      "x": 0,
      "y": -8,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-1--8",
      "x": -1,
      "y": -8,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-2--8",
      "x": -2,
      "y": -8,
      "tier": 3,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "0--9",
      "x": 0,
      "y": -9,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-1--9",
      "x": -1,
      "y": -9,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-2--9",
      "x": -2,
      "y": -9,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-3--9",
      "x": -3,
      "y": -9,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-2--10",
      "x": -2,
      "y": -10,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-4--9",
      "x": -4,
      "y": -9,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-3--10",
      "x": -3,
      "y": -10,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-4--10",
      "x": -4,
      "y": -10,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-5--9",
      "x": -5,
      "y": -9,
      "tier": 3,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-5--10",
      "x": -5,
      "y": -10,
      "tier": 3,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-6--10",
      "x": -6,
      "y": -10,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-7--10",
      "x": -7,
      "y": -10,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-6--11",
      "x": -6,
      "y": -11,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-8--10",
      "x": -8,
      "y": -10,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-8--9",
      "x": -8,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-9--9",
      "x": -9,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-9--10",
      "x": -9,
      "y": -10,
      "tier": 2,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-10--9",
      "x": -10,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-10--10",
      "x": -10,
      "y": -10,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-11--9",
      "x": -11,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-11--8",
      "x": -11,
      "y": -8,
      "tier": 2,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-11--10",
      "x": -11,
      "y": -10,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-12--8",
      "x": -12,
      "y": -8,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-12--9",
      "x": -12,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-13--8",
      "x": -13,
      "y": -8,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-13--7",
      "x": -13,
      "y": -7,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-13--9",
      "x": -13,
      "y": -9,
      "tier": 2,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-14--7",
      "x": -14,
      "y": -7,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-14--8",
      "x": -14,
      "y": -8,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-14--6",
      "x": -14,
      "y": -6,
      "tier": 2,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-15--6",
      "x": -15,
      "y": -6,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-15--7",
      "x": -15,
      "y": -7,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-16--5",
      "x": -16,
      "y": -5,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-16--6",
      "x": -16,
      "y": -6,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-16--4",
      "x": -16,
      "y": -4,
      "tier": 1,
      "elements": [
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-17--4",
      "x": -17,
      "y": -4,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-17--5",
      "x": -17,
      "y": -5,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-17--3",
      "x": -17,
      "y": -3,
      "tier": 1,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-18--3",
      "x": -18,
      "y": -3,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-18--4",
      "x": -18,
      "y": -4,
      "tier": 1,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-18--2",
      "x": -18,
      "y": -2,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "0--3",
      "x": 0,
      "y": -3,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-1--3",
      "x": -1,
      "y": -3,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-2--3",
      "x": -2,
      "y": -3,
      "tier": 5,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-1--4",
      "x": -1,
      "y": -4,
      "tier": 5,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-2--4",
      "x": -2,
      "y": -4,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-3--3",
      "x": -3,
      "y": -3,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-1--5",
      "x": -1,
      "y": -5,
      "tier": 5,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-3--4",
      "x": -3,
      "y": -4,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-2--5",
      "x": -2,
      "y": -5,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-3--5",
      "x": -3,
      "y": -5,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-2--6",
      "x": -2,
      "y": -6,
      "tier": 4,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-4--4",
      "x": -4,
      "y": -4,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-4--5",
      "x": -4,
      "y": -5,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-3--6",
      "x": -3,
      "y": -6,
      "tier": 4,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-5--5",
      "x": -5,
      "y": -5,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-4--6",
      "x": -4,
      "y": -6,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-5--6",
      "x": -5,
      "y": -6,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-6--4",
      "x": -6,
      "y": -4,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-6--5",
      "x": -6,
      "y": -5,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-6--6",
      "x": -6,
      "y": -6,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-7--4",
      "x": -7,
      "y": -4,
      "tier": 4,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-7--5",
      "x": -7,
      "y": -5,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-7--6",
      "x": -7,
      "y": -6,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-8--4",
      "x": -8,
      "y": -4,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-8--5",
      "x": -8,
      "y": -5,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-9--4",
      "x": -9,
      "y": -4,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-9--5",
      "x": -9,
      "y": -5,
      "tier": 3,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-9--3",
      "x": -9,
      "y": -3,
      "tier": 3,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-10--3",
      "x": -10,
      "y": -3,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-10--4",
      "x": -10,
      "y": -4,
      "tier": 3,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-10--2",
      "x": -10,
      "y": -2,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-11--2",
      "x": -11,
      "y": -2,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-11--3",
      "x": -11,
      "y": -3,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-11--4",
      "x": -11,
      "y": -4,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-11--1",
      "x": -11,
      "y": -1,
      "tier": 3,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-12--2",
      "x": -12,
      "y": -2,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-12--1",
      "x": -12,
      "y": -1,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-12--3",
      "x": -12,
      "y": -3,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-12-0",
      "x": -12,
      "y": 0,
      "tier": 2,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-13--1",
      "x": -13,
      "y": -1,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-13-0",
      "x": -13,
      "y": 0,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-13-1",
      "x": -13,
      "y": 1,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-13-2",
      "x": -13,
      "y": 2,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-0",
      "x": -14,
      "y": 0,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-1",
      "x": -14,
      "y": 1,
      "tier": 2,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-14-2",
      "x": -14,
      "y": 2,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-3",
      "x": -14,
      "y": 3,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-4",
      "x": -14,
      "y": 4,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-3",
      "x": -15,
      "y": 3,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-5",
      "x": -14,
      "y": 5,
      "tier": 2,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-15-4",
      "x": -15,
      "y": 4,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-5",
      "x": -15,
      "y": 5,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-6",
      "x": -14,
      "y": 6,
      "tier": 2,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-6",
      "x": -15,
      "y": 6,
      "tier": 1,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "-14-7",
      "x": -14,
      "y": 7,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-15-7",
      "x": -15,
      "y": 7,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-8",
      "x": -14,
      "y": 8,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-8",
      "x": -15,
      "y": 8,
      "tier": 1,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-14-9",
      "x": -14,
      "y": 9,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-9",
      "x": -15,
      "y": 9,
      "tier": 1,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-14-10",
      "x": -14,
      "y": 10,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-15-10",
      "x": -15,
      "y": 10,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-14-11",
      "x": -14,
      "y": 11,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-2--2",
      "x": -2,
      "y": -2,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-2--1",
      "x": -2,
      "y": -1,
      "tier": 6,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-3--1",
      "x": -3,
      "y": -1,
      "tier": 5,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-3--2",
      "x": -3,
      "y": -2,
      "tier": 5,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-3-0",
      "x": -3,
      "y": 0,
      "tier": 5,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-4-0",
      "x": -4,
      "y": 0,
      "tier": 5,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-4--1",
      "x": -4,
      "y": -1,
      "tier": 5,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-4--2",
      "x": -4,
      "y": -2,
      "tier": 5,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-4--3",
      "x": -4,
      "y": -3,
      "tier": 5,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-5-0",
      "x": -5,
      "y": 0,
      "tier": 5,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-5--1",
      "x": -5,
      "y": -1,
      "tier": 5,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-5--2",
      "x": -5,
      "y": -2,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-5--3",
      "x": -5,
      "y": -3,
      "tier": 4,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-6--1",
      "x": -6,
      "y": -1,
      "tier": 4,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-6-0",
      "x": -6,
      "y": 0,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-6--2",
      "x": -6,
      "y": -2,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-6-1",
      "x": -6,
      "y": 1,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-7--1",
      "x": -7,
      "y": -1,
      "tier": 4,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-7-0",
      "x": -7,
      "y": 0,
      "tier": 4,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-7-1",
      "x": -7,
      "y": 1,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-7-2",
      "x": -7,
      "y": 2,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-0",
      "x": -8,
      "y": 0,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-1",
      "x": -8,
      "y": 1,
      "tier": 4,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-2",
      "x": -8,
      "y": 2,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-3",
      "x": -8,
      "y": 3,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-2",
      "x": -9,
      "y": 2,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-4",
      "x": -8,
      "y": 4,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-3",
      "x": -9,
      "y": 3,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-4",
      "x": -9,
      "y": 4,
      "tier": 3,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-8-5",
      "x": -8,
      "y": 5,
      "tier": 3,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-9-5",
      "x": -9,
      "y": 5,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-6",
      "x": -9,
      "y": 6,
      "tier": 3,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-7",
      "x": -9,
      "y": 7,
      "tier": 3,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-10-6",
      "x": -10,
      "y": 6,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-8",
      "x": -9,
      "y": 8,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-8",
      "x": -8,
      "y": 8,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-8-9",
      "x": -8,
      "y": 9,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-9",
      "x": -9,
      "y": 9,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-10",
      "x": -8,
      "y": 10,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-9-10",
      "x": -9,
      "y": 10,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-11",
      "x": -8,
      "y": 11,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-7-11",
      "x": -7,
      "y": 11,
      "tier": 2,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-9-11",
      "x": -9,
      "y": 11,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-7-12",
      "x": -7,
      "y": 12,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-8-12",
      "x": -8,
      "y": 12,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-7-13",
      "x": -7,
      "y": 13,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-6-13",
      "x": -6,
      "y": 13,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-8-13",
      "x": -8,
      "y": 13,
      "tier": 2,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-6-14",
      "x": -6,
      "y": 14,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-7-14",
      "x": -7,
      "y": 14,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-5-14",
      "x": -5,
      "y": 14,
      "tier": 2,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-5-15",
      "x": -5,
      "y": 15,
      "tier": 2,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-6-15",
      "x": -6,
      "y": 15,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-4-16",
      "x": -4,
      "y": 16,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-5-16",
      "x": -5,
      "y": 16,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-3-16",
      "x": -3,
      "y": 16,
      "tier": 1,
      "elements": [
        "dark",
        "fire"
      ]
    },
    {
      "seed": "-3-17",
      "x": -3,
      "y": 17,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-4-17",
      "x": -4,
      "y": 17,
      "tier": 1,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-2-17",
      "x": -2,
      "y": 17,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-3-18",
      "x": -3,
      "y": 18,
      "tier": 1,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-2-0",
      "x": -2,
      "y": 0,
      "tier": 6,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-2-1",
      "x": -2,
      "y": 1,
      "tier": 6,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-2-2",
      "x": -2,
      "y": 2,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "-3-1",
      "x": -3,
      "y": 1,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-2",
      "x": -3,
      "y": 2,
      "tier": 5,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "-2-3",
      "x": -2,
      "y": 3,
      "tier": 5,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-4-1",
      "x": -4,
      "y": 1,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-3",
      "x": -3,
      "y": 3,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-2",
      "x": -4,
      "y": 2,
      "tier": 5,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-4-3",
      "x": -4,
      "y": 3,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-2",
      "x": -5,
      "y": 2,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-4",
      "x": -3,
      "y": 4,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-4",
      "x": -4,
      "y": 4,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-3",
      "x": -5,
      "y": 3,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-5",
      "x": -4,
      "y": 5,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-4",
      "x": -5,
      "y": 4,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-5",
      "x": -5,
      "y": 5,
      "tier": 4,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "-3-6",
      "x": -3,
      "y": 6,
      "tier": 4,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-4-6",
      "x": -4,
      "y": 6,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-6",
      "x": -5,
      "y": 6,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-7",
      "x": -3,
      "y": 7,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-7",
      "x": -4,
      "y": 7,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-7",
      "x": -5,
      "y": 7,
      "tier": 3,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "-3-8",
      "x": -3,
      "y": 8,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-8",
      "x": -4,
      "y": 8,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-9",
      "x": -3,
      "y": 9,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-4-9",
      "x": -4,
      "y": 9,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-2-9",
      "x": -2,
      "y": 9,
      "tier": 3,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "-2-10",
      "x": -2,
      "y": 10,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-10",
      "x": -3,
      "y": 10,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-1-10",
      "x": -1,
      "y": 10,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-1-11",
      "x": -1,
      "y": 11,
      "tier": 3,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "-2-11",
      "x": -2,
      "y": 11,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-3-11",
      "x": -3,
      "y": 11,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "0-11",
      "x": 0,
      "y": 11,
      "tier": 3,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-1-12",
      "x": -1,
      "y": 12,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "0-12",
      "x": 0,
      "y": 12,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-2-12",
      "x": -2,
      "y": 12,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "1-12",
      "x": 1,
      "y": 12,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "0-13",
      "x": 0,
      "y": 13,
      "tier": 2,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "1-13",
      "x": 1,
      "y": 13,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "2-13",
      "x": 2,
      "y": 13,
      "tier": 2,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "3-13",
      "x": 3,
      "y": 13,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "1-14",
      "x": 1,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "2-14",
      "x": 2,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "3-14",
      "x": 3,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "4-14",
      "x": 4,
      "y": 14,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "5-14",
      "x": 5,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "4-15",
      "x": 4,
      "y": 15,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "6-14",
      "x": 6,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "5-15",
      "x": 5,
      "y": 15,
      "tier": 2,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "6-15",
      "x": 6,
      "y": 15,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "7-14",
      "x": 7,
      "y": 14,
      "tier": 2,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "7-15",
      "x": 7,
      "y": 15,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "8-14",
      "x": 8,
      "y": 14,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "8-15",
      "x": 8,
      "y": 15,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "9-14",
      "x": 9,
      "y": 14,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "9-15",
      "x": 9,
      "y": 15,
      "tier": 1,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "10-14",
      "x": 10,
      "y": 14,
      "tier": 1,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "10-15",
      "x": 10,
      "y": 15,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "11-14",
      "x": 11,
      "y": 14,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "11-15",
      "x": 11,
      "y": 15,
      "tier": 1,
      "elements": [
        "fire",
        "earth"
      ]
    },
    {
      "seed": "12-14",
      "x": 12,
      "y": 14,
      "tier": 1,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-1-2",
      "x": -1,
      "y": 2,
      "tier": 6,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "0-2",
      "x": 0,
      "y": 2,
      "tier": 6,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "0-3",
      "x": 0,
      "y": 3,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "-1-3",
      "x": -1,
      "y": 3,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "1-3",
      "x": 1,
      "y": 3,
      "tier": 5,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "1-4",
      "x": 1,
      "y": 4,
      "tier": 5,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "0-4",
      "x": 0,
      "y": 4,
      "tier": 5,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "-1-4",
      "x": -1,
      "y": 4,
      "tier": 5,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-2-4",
      "x": -2,
      "y": 4,
      "tier": 5,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "1-5",
      "x": 1,
      "y": 5,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "0-5",
      "x": 0,
      "y": 5,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "-1-5",
      "x": -1,
      "y": 5,
      "tier": 5,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "-2-5",
      "x": -2,
      "y": 5,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "0-6",
      "x": 0,
      "y": 6,
      "tier": 4,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "1-6",
      "x": 1,
      "y": 6,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-1-6",
      "x": -1,
      "y": 6,
      "tier": 4,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "2-6",
      "x": 2,
      "y": 6,
      "tier": 4,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "0-7",
      "x": 0,
      "y": 7,
      "tier": 4,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "1-7",
      "x": 1,
      "y": 7,
      "tier": 4,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "2-7",
      "x": 2,
      "y": 7,
      "tier": 4,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "3-7",
      "x": 3,
      "y": 7,
      "tier": 4,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "1-8",
      "x": 1,
      "y": 8,
      "tier": 4,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "2-8",
      "x": 2,
      "y": 8,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "3-8",
      "x": 3,
      "y": 8,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "4-8",
      "x": 4,
      "y": 8,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "3-9",
      "x": 3,
      "y": 9,
      "tier": 3,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "5-8",
      "x": 5,
      "y": 8,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "4-9",
      "x": 4,
      "y": 9,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "5-9",
      "x": 5,
      "y": 9,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "6-8",
      "x": 6,
      "y": 8,
      "tier": 3,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "6-9",
      "x": 6,
      "y": 9,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "7-9",
      "x": 7,
      "y": 9,
      "tier": 3,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "8-9",
      "x": 8,
      "y": 9,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "7-10",
      "x": 7,
      "y": 10,
      "tier": 3,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "9-9",
      "x": 9,
      "y": 9,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "9-8",
      "x": 9,
      "y": 8,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "10-8",
      "x": 10,
      "y": 8,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "10-9",
      "x": 10,
      "y": 9,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "11-8",
      "x": 11,
      "y": 8,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "11-9",
      "x": 11,
      "y": 9,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "12-8",
      "x": 12,
      "y": 8,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "12-7",
      "x": 12,
      "y": 7,
      "tier": 2,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "12-9",
      "x": 12,
      "y": 9,
      "tier": 2,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "13-7",
      "x": 13,
      "y": 7,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "13-8",
      "x": 13,
      "y": 8,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "14-7",
      "x": 14,
      "y": 7,
      "tier": 2,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "14-6",
      "x": 14,
      "y": 6,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "14-8",
      "x": 14,
      "y": 8,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "15-6",
      "x": 15,
      "y": 6,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "15-7",
      "x": 15,
      "y": 7,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "15-5",
      "x": 15,
      "y": 5,
      "tier": 2,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "16-5",
      "x": 16,
      "y": 5,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "16-6",
      "x": 16,
      "y": 6,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "17-4",
      "x": 17,
      "y": 4,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "17-5",
      "x": 17,
      "y": 5,
      "tier": 1,
      "elements": [
        "earth",
        "light"
      ]
    },
    {
      "seed": "17-3",
      "x": 17,
      "y": 3,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "18-3",
      "x": 18,
      "y": 3,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "18-4",
      "x": 18,
      "y": 4,
      "tier": 1,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "18-2",
      "x": 18,
      "y": 2,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "19-2",
      "x": 19,
      "y": 2,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "19-3",
      "x": 19,
      "y": 3,
      "tier": 1,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "19-1",
      "x": 19,
      "y": 1,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "1-2",
      "x": 1,
      "y": 2,
      "tier": 6,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "2-2",
      "x": 2,
      "y": 2,
      "tier": 5,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "3-2",
      "x": 3,
      "y": 2,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "2-3",
      "x": 2,
      "y": 3,
      "tier": 5,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "3-3",
      "x": 3,
      "y": 3,
      "tier": 5,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "4-2",
      "x": 4,
      "y": 2,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "2-4",
      "x": 2,
      "y": 4,
      "tier": 5,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "4-3",
      "x": 4,
      "y": 3,
      "tier": 5,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "3-4",
      "x": 3,
      "y": 4,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "4-4",
      "x": 4,
      "y": 4,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "3-5",
      "x": 3,
      "y": 5,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "5-3",
      "x": 5,
      "y": 3,
      "tier": 4,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "5-4",
      "x": 5,
      "y": 4,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "4-5",
      "x": 4,
      "y": 5,
      "tier": 4,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "6-4",
      "x": 6,
      "y": 4,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "5-5",
      "x": 5,
      "y": 5,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "6-5",
      "x": 6,
      "y": 5,
      "tier": 4,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "7-3",
      "x": 7,
      "y": 3,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "7-4",
      "x": 7,
      "y": 4,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "7-5",
      "x": 7,
      "y": 5,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "8-3",
      "x": 8,
      "y": 3,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "8-4",
      "x": 8,
      "y": 4,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "8-5",
      "x": 8,
      "y": 5,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "9-3",
      "x": 9,
      "y": 3,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "9-4",
      "x": 9,
      "y": 4,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "10-3",
      "x": 10,
      "y": 3,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "10-4",
      "x": 10,
      "y": 4,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "10-2",
      "x": 10,
      "y": 2,
      "tier": 3,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "11-2",
      "x": 11,
      "y": 2,
      "tier": 3,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "11-3",
      "x": 11,
      "y": 3,
      "tier": 3,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "11-1",
      "x": 11,
      "y": 1,
      "tier": 3,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "12-1",
      "x": 12,
      "y": 1,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "12-2",
      "x": 12,
      "y": 2,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "12-3",
      "x": 12,
      "y": 3,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "12-0",
      "x": 12,
      "y": 0,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "13-1",
      "x": 13,
      "y": 1,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "13-0",
      "x": 13,
      "y": 0,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "13-2",
      "x": 13,
      "y": 2,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "13--1",
      "x": 13,
      "y": -1,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "14-0",
      "x": 14,
      "y": 0,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "14--1",
      "x": 14,
      "y": -1,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "14--2",
      "x": 14,
      "y": -2,
      "tier": 2,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "14--3",
      "x": 14,
      "y": -3,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--1",
      "x": 15,
      "y": -1,
      "tier": 2,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "15--2",
      "x": 15,
      "y": -2,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--3",
      "x": 15,
      "y": -3,
      "tier": 2,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "15--4",
      "x": 15,
      "y": -4,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--5",
      "x": 15,
      "y": -5,
      "tier": 2,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--4",
      "x": 16,
      "y": -4,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--6",
      "x": 15,
      "y": -6,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--5",
      "x": 16,
      "y": -5,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--6",
      "x": 16,
      "y": -6,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "15--7",
      "x": 15,
      "y": -7,
      "tier": 1,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "16--7",
      "x": 16,
      "y": -7,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--8",
      "x": 15,
      "y": -8,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--8",
      "x": 16,
      "y": -8,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--9",
      "x": 15,
      "y": -9,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--9",
      "x": 16,
      "y": -9,
      "tier": 1,
      "elements": [
        "fire",
        "earth",
        "wind",
        "dark"
      ]
    },
    {
      "seed": "15--10",
      "x": 15,
      "y": -10,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "16--10",
      "x": 16,
      "y": -10,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--11",
      "x": 15,
      "y": -11,
      "tier": 1,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "16--11",
      "x": 16,
      "y": -11,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "15--12",
      "x": 15,
      "y": -12,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "3-1",
      "x": 3,
      "y": 1,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "4-1",
      "x": 4,
      "y": 1,
      "tier": 5,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "5-0",
      "x": 5,
      "y": 0,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "5-1",
      "x": 5,
      "y": 1,
      "tier": 5,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "5-2",
      "x": 5,
      "y": 2,
      "tier": 4,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "6--1",
      "x": 6,
      "y": -1,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "6-0",
      "x": 6,
      "y": 0,
      "tier": 4,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "6-1",
      "x": 6,
      "y": 1,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "6-2",
      "x": 6,
      "y": 2,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "7-0",
      "x": 7,
      "y": 0,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "7--1",
      "x": 7,
      "y": -1,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "7-1",
      "x": 7,
      "y": 1,
      "tier": 4,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "7--2",
      "x": 7,
      "y": -2,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8-0",
      "x": 8,
      "y": 0,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--1",
      "x": 8,
      "y": -1,
      "tier": 4,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--2",
      "x": 8,
      "y": -2,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--3",
      "x": 8,
      "y": -3,
      "tier": 3,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "9--1",
      "x": 9,
      "y": -1,
      "tier": 3,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "9--2",
      "x": 9,
      "y": -2,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "9--3",
      "x": 9,
      "y": -3,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "9--4",
      "x": 9,
      "y": -4,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--3",
      "x": 10,
      "y": -3,
      "tier": 3,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "9--5",
      "x": 9,
      "y": -5,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--4",
      "x": 10,
      "y": -4,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--5",
      "x": 10,
      "y": -5,
      "tier": 3,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "9--6",
      "x": 9,
      "y": -6,
      "tier": 3,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--6",
      "x": 10,
      "y": -6,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--7",
      "x": 10,
      "y": -7,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--8",
      "x": 10,
      "y": -8,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "11--7",
      "x": 11,
      "y": -7,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--9",
      "x": 10,
      "y": -9,
      "tier": 2,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "9--9",
      "x": 9,
      "y": -9,
      "tier": 2,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "9--10",
      "x": 9,
      "y": -10,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--10",
      "x": 10,
      "y": -10,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "9--11",
      "x": 9,
      "y": -11,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--11",
      "x": 10,
      "y": -11,
      "tier": 2,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "9--12",
      "x": 9,
      "y": -12,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--12",
      "x": 8,
      "y": -12,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "10--12",
      "x": 10,
      "y": -12,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--13",
      "x": 8,
      "y": -13,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "9--13",
      "x": 9,
      "y": -13,
      "tier": 2,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "8--14",
      "x": 8,
      "y": -14,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "7--14",
      "x": 7,
      "y": -14,
      "tier": 2,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "9--14",
      "x": 9,
      "y": -14,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "7--15",
      "x": 7,
      "y": -15,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "8--15",
      "x": 8,
      "y": -15,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "6--15",
      "x": 6,
      "y": -15,
      "tier": 1,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "6--16",
      "x": 6,
      "y": -16,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "7--16",
      "x": 7,
      "y": -16,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "5--17",
      "x": 5,
      "y": -17,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "6--17",
      "x": 6,
      "y": -17,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "4--17",
      "x": 4,
      "y": -17,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "4--18",
      "x": 4,
      "y": -18,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "5--18",
      "x": 5,
      "y": -18,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "3--18",
      "x": 3,
      "y": -18,
      "tier": 1,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "3--19",
      "x": 3,
      "y": -19,
      "tier": 1,
      "elements": [
        "wind",
        "cold"
      ]
    },
    {
      "seed": "4--19",
      "x": 4,
      "y": -19,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "2--19",
      "x": 2,
      "y": -19,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "-1--6",
      "x": -1,
      "y": -6,
      "tier": 4,
      "elements": [
        "light",
        "cold",
        "water",
        "lightning"
      ]
    },
    {
      "seed": "-5--4",
      "x": -5,
      "y": -4,
      "tier": 4,
      "elements": [
        "lightning",
        "dark"
      ]
    },
    {
      "seed": "2-5",
      "x": 2,
      "y": 5,
      "tier": 4,
      "elements": [
        "light",
        "wind"
      ]
    },
    {
      "seed": "-3-5",
      "x": -3,
      "y": 5,
      "tier": 4,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "-5-1",
      "x": -5,
      "y": 1,
      "tier": 5,
      "elements": [
        "earth"
      ]
    },
    {
      "seed": "6-3",
      "x": 6,
      "y": 3,
      "tier": 4,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "6--2",
      "x": 6,
      "y": -2,
      "tier": 4,
      "elements": [
        "cold",
        "water"
      ]
    },
    {
      "seed": "0-18",
      "x": 0,
      "y": 18,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "13-14",
      "x": 13,
      "y": 14,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "19-0",
      "x": 19,
      "y": 0,
      "tier": 1,
      "elements": [
        "light"
      ]
    },
    {
      "seed": "15--13",
      "x": 15,
      "y": -13,
      "tier": 1,
      "elements": [
        "wind"
      ]
    },
    {
      "seed": "1--19",
      "x": 1,
      "y": -19,
      "tier": 1,
      "elements": [
        "cold"
      ]
    },
    {
      "seed": "-12--15",
      "x": -12,
      "y": -15,
      "tier": 1,
      "elements": [
        "water"
      ]
    },
    {
      "seed": "-18--1",
      "x": -18,
      "y": -1,
      "tier": 1,
      "elements": [
        "lightning"
      ]
    },
    {
      "seed": "-14-12",
      "x": -14,
      "y": 12,
      "tier": 1,
      "elements": [
        "dark"
      ]
    },
    {
      "seed": "-1-18",
      "x": -1,
      "y": 18,
      "tier": 1,
      "elements": [
        "all"
      ]
    },
    {
      "seed": "-2-18",
      "x": -2,
      "y": 18,
      "tier": 1,
      "elements": [
        "fire"
      ]
    },
    {
      "seed": "-3--8",
      "x": -3,
      "y": -8,
      "tier": 3,
      "elements": [
        "lightning",
        "dark"
      ]
    }
  ]
}